<template>
  <!-- DOCK -->
  <template v-if="config?.dock?.id != undefined">
    <div class="flex flex-col">
      <div class="flex justify-between">
        <span class="text-g4">{{ $e("Dock")}} :</span>
        <div class="flex">
          <HMS_btn
            :config="config"
            :classTpl="{
              div: 'cursor-pointer aspect-square ml-4 w-[24px]',
              svg: 'w-full',
            }"
          />
          <LastDockStatus :config="config" />
        </div>
      </div>

      <h3>#{{ config.dock.id }} - {{ config.dock.name }}</h3>

      <DockWindRain :config="config" />

      <DockLight :config="config" />
    </div>
  </template>

  <!-- RC+ -->
  <template v-if="config?.rcPlus?.id != undefined">
    <!-- TODO -->
    <div class="flex flex-col">
      <div class="flex justify-between">
        <span class="text-g4">RC+ :</span>

        <RcPlusLastStatus :config="config" />
      </div>

      <h3>#{{ config.rcPlus.id }} - {{ config.rcPlus.name }}</h3>

      <RcPlusBatt :config="config" />
      <RcPlus4GNetQuality :config="config" />
      <RcPlus4GNetQualityToDrone :config="config" />
      <RcPlus4G :config="config" />
      <RcPlusSdrNetQuality :config="config" />
      <RcPlusSdr :config="config" />
    </div>
  </template>

  <!-- DRONE -->
  <template v-if="config?.drone?.id != undefined">
    <div class="flex flex-col border-t border-g2 pt-4 mt-4">
      <div class="flex justify-between">
        <span class="text-g4">{{ $e("Drone")}} :</span>
        <LastDroneStatus :config="config" />
      </div>

      <h3>#{{ config.drone.id }} - {{ config.drone.name }}</h3>

      <DroneStorage :config="config" />
    </div>
  </template>
</template>

<script>
// DOCK ---
import LastDroneStatus from "@/partials/Device/Template/Drone/LastDroneStatus.vue";
import DockWindRain from "@/partials/Device/Template/Dock/DockWindRain.vue";
import DockLight from "@/partials/Device/Template/Dock/DockLight.vue";
import HMS_btn from "@/partials/Device/Template/HMS/HMS_btn.vue";

// RC ---
import RcPlusLastStatus from "@/partials/Device/Template/Rc+/RcPlusLastStatus.vue";
import RcPlusBatt from "@/partials/Device/Template/Rc+/RcPlusBatt.vue";
import RcPlus4GNetQuality from "@/partials/Device/Template/Rc+/RcPlus4GNetQuality.vue";
import RcPlus4GNetQualityToDrone from "@/partials/Device/Template/Rc+/RcPlus4GNetQualityToDrone.vue";
import RcPlus4G from "@/partials/Device/Template/Rc+/RcPlus4G.vue";
import RcPlusSdrNetQuality from "@/partials/Device/Template/Rc+/RcPlusSdrNetQuality.vue";
import RcPlusSdr from "@/partials/Device/Template/Rc+/RcPlusSdr.vue";

// DRONE ---
import LastDockStatus from "@/partials/Device/Template/Dock/LastDockStatus.vue";
import DroneStorage from "@/partials/Device/Template/Drone/DroneStorage.vue";

export default {
  name: "POPUP_DEVICE_DATA",
  components: {
    HMS_btn,
    LastDockStatus,
    DockWindRain,
    DockLight,
    // RC ---
    RcPlusLastStatus,
    RcPlusBatt,
    RcPlus4GNetQuality,
    RcPlus4GNetQualityToDrone,
    RcPlus4G,
    RcPlusSdrNetQuality,
    RcPlusSdr,
    // DRONE ---
    LastDroneStatus,
    DroneStorage,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
